import tw, { styled } from 'twin.macro'


const Title = styled.h2(({ variant }) => [
  // The common button styles added with the tw import
  tw`text-[150px] leading-normal`,
])

export default Title
